"use client";

import Link from "next/link";
import { useState } from "react";
import { ShoppingCart } from "lucide-react";
import { useAuthContext } from "@core/helpers/client/contexts/AuthContext";
import CartPreviewModal from "./_CartPreviewModal";

export default function CartButton() {
    const { cart } = useAuthContext();
    const [isOpen, setIsOpen] = useState(false);

    const badge = cart?.products?.reduce((a, b) => a + (b?.count || 0), 0) || 0;

    return (
        <div
            className="relative inline-block"
            onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => setIsOpen(false)}
        >
            <Link href="/cart" aria-label={badge > 0 ? `سبد خرید، ${badge} محصول` : "سبد خرید"} className="relative flex items-center justify-center w-10 h-10 rounded-full">
                <ShoppingCart size={24} className="text-jmt-neutral-800" />
                {badge > 0 && (
                    <div className="flex items-center justify-center absolute top-0 right-0.5 w-5 h-5 bg-jmt-primary-700 border border-jmt-neutral-100 rounded-md">
                        <span className="text-jmt-white text-[10px] font-bold">
                            {badge}
                        </span>
                    </div>
                )}
            </Link>

            {isOpen && badge > 0 && (
                <CartPreviewModal cart={cart} badge={badge} />
            )}
        </div>
    );
}

